import ToggleLength from './ToggleLength';
import { SALES_SPACE_GROUP, TURNOVER_CLASSES } from '../../../config';

const ClassificationDetails = {
    getVisitingTime(classificationVisitingTimes) {
        const selected = classificationVisitingTimes?.find(time => time.selected) || classificationVisitingTimes?.[0];
        return selected ? selected.classificationVistingTimeValue : null;
    },
    getFrequency(classificationFrequencies) {
        const selected = classificationFrequencies?.find(freq => freq.selected) || classificationFrequencies?.[0];
        return selected ? `${selected.classificationFrequencyValue} st/säljcykel` : null;
    },
    getSalesSpace(values = []) {
        if (values.length < 2) return null;
        const minGroup = SALES_SPACE_GROUP.find(group => group.label === values[0]);
        const maxGroup = SALES_SPACE_GROUP.find(group => group.label === values[1]);
        return minGroup && maxGroup ? `${minGroup.min}-${maxGroup.max}` : null;
    },
    getTurnover(values = []) {
        if (values.length < 2) return null;
        const minGroup = TURNOVER_CLASSES.find(group => group.label === values[0]);
        const maxGroup = TURNOVER_CLASSES.find(group => group.label === values[1]);
        return minGroup && maxGroup ? `${minGroup.min}-${maxGroup.max}` : null;
    }
};

export const buildTableColumns = ({ renderActions } = {}) => {
    const columns = [
        {
            key: 'name',
            label: 'Namn',
            isTextCell: true,
            isTextHeader: true,
            render: (row) => row.name
        },
        {
            key: 'frequency',
            label: 'Besöksfrekvens',
            render: (row) => ClassificationDetails.getFrequency(row.classificationFrequencies)
        },
        {
            key: 'visitingTime',
            label: 'Besökstid',
            sublabel: 'H',
            render: (row) => ClassificationDetails.getVisitingTime(row.classificationVisitingTimes)
        },
        {
            key: 'chains',
            label: 'Kedjor',
            isTextCell: true,
            cellClassNames: { 'table__data--width25': true },
            render: (row) => (
                <ToggleLength text={row.chains.map(chain => chain.chainName).join(', ')} />
            )
        },
        {
            key: 'turnover',
            label: 'Omsättning',
            sublabel: 'KKR',
            render: (row) => ClassificationDetails.getTurnover(row.turnovers)
        },
        {
            key: 'salesSpace',
            label: 'Säljyta',
            sublabel: 'm2',
            render: (row) => ClassificationDetails.getSalesSpace(row.salesSpaceGroups)
        }
    ];

    if (renderActions) {
        columns.push({
            key: 'actions',
            label: '',
            render: renderActions
        });
    }

    return columns;
};

export default ClassificationDetails;

